import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { allocation, nextAllocation }: Boundaries["editAllocation"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.allocation.uuid === allocation.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { allocation, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { allocation, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  allocation: Boundaries["editAllocation"]["success"],
): State {
  return state.map((res) =>
    res.allocation.uuid === allocation.uuid
      ? { allocation, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { allocation }: Boundaries["editAllocation"]["failure"],
): State {
  return state.map((res) =>
    res.allocation.uuid === allocation.uuid
      ? { allocation, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editAllocationRequested]: handleRequest,
    [events.editAllocationSucceeded]: handleSuccess,
    [events.editAllocationFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
